import { expandedState } from '@atlaskit/editor-common/expand';
export var toggleExpandRange = function toggleExpandRange(from, to) {
  var open = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (_ref) {
    var tr = _ref.tr;
    var _tr$doc$type$schema$n = tr.doc.type.schema.nodes,
      expand = _tr$doc$type$schema$n.expand,
      nestedExpand = _tr$doc$type$schema$n.nestedExpand;
    var fromClamped = from && from >= 0 ? from : 0;
    var toClamped = to && to <= tr.doc.content.size ? to : tr.doc.content.size;
    tr.doc.nodesBetween(fromClamped, toClamped, function (node) {
      if ([expand, nestedExpand].includes(node.type)) {
        expandedState.set(node, open);
      }
    });
    return null;
  };
};